import { useEffect } from "react";

// Pages that leave the SPA via a full-page redirect (window.location.href to
// the SSO server) can get restored from the browser's back/forward cache
// when the user hits native Back/Forward, instead of a fresh load. bfcache
// restores the exact in-memory snapshot from right before the page
// unloaded - a submit button frozen mid-"Redirecting...", stale form data,
// guards that never re-run - none of it reflects current app state. Forcing
// a real reload on bfcache restore fixes that.
export default function useBfcacheReload() {
  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        window.location.reload();
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);
}
